import React, { useState } from "react";
import { List } from "antd";
import PropTypes from "prop-types";
import { getDocuments, esqDocuments } from "../../../services/api-repo";
import TableWithControls from "../../common/table-with-controls";
import { withUser } from "@unifiedpatents/sso";

const RepoTable = ({ filter, defaultSort, accessLevel, esUrl, allCols, selectedColumns, rowKey, tableKey = "repoTable" }) => {
  const fetcher = q => getDocuments(esUrl, q).then(json => ({
    data: json.hits.hits.map(e => {
      return { ...e._source, highlight: e.highlight, _id: e._id, _score: e._score };
    }),
    total: json.hits.total.value,
  }));
  const [queries, setQueries] = useState({ sort: defaultSort, ...filter });
  const onQueryChange = queriesNew => setQueries(({ sort: defaultSort, ...queriesNew }));
  const columns = [
    {
      title: "Rank",
      dataIndex: "_rank",
      width: 70,
      key: "rowNumber",
      render: (text, record, index) => (queries.offset || 0) + index + 1
    },
    ...allCols
  ];
  if (queries.full_text) {
    columns.push({
      title: "Relevance",
      dataIndex: "_score",
      width: 70,
      render: num => (num ? num.toFixed(2) : undefined)
    });
  }
  const expandable = queries.full_text ? {
    defaultExpandAllRows: true,
    expandedRowRender: record => record.highlight ? (
      <List
        dataSource={record["highlight"]["attachments.attachment.content"] || record["highlight"]["content"]}
        renderItem={d => (
          <List.Item>
            <div dangerouslySetInnerHTML={{ __html: d }} />
          </List.Item>
        )}
        size="small"
      />
    ) : null
  } : undefined;
  return (
    <TableWithControls
      queries={queries}
      fetcher={fetcher}
      onChange={onQueryChange}
      columns={columns}
      columnKeysSelected={["_rank", ...selectedColumns]}
      rowKey={rowKey}
      tableKey={tableKey}
      expandable={expandable}
      shouldExport={accessLevel === "full"}
      exportESUrl={esUrl}
      exportESQueryBuilder={esqDocuments}
      shouldSelectColumns={accessLevel === "full"}
      shouldPaginate={true}
    />
  );
};

RepoTable.propTypes = {
  filter: PropTypes.object,
  defaultSort: PropTypes.string,
  accessLevel: PropTypes.string,
  esUrl: PropTypes.string,
  allCols: PropTypes.array,
  selectedColumns: PropTypes.array,
  tableKey: PropTypes.string,
  rowKey: PropTypes.string
};

export default withUser(RepoTable);
